export default __webpack_public_path__ + "images/466c140c05a1f5f8c10e8d5cd2f4a446-hi-friend-en.svg";